import React, { useState, useEffect } from 'react';
import {  useNavigate, useParams } from 'react-router-dom';
import { apiService } from '../../service/Api';


const BattlecardResult = () => {
  const [activeVersion, setActiveVersion] = useState('external'); // 'external' or 'internal'
  const [battlecardData, setBattlecardData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  
  const navigate = useNavigate();
  const {key} = useParams();
  useEffect(() => { 
    if(!key){
      navigate('/battlecard');
    }
    fetchBattlecard();
  }, [key]);

      // If no data, redirect back to form
     
 

  const fetchBattlecard = async () => {
    try {
        setLoading(true);
        setError(null);
      // Call the new API endpoint to get data by ID
      const response = await apiService.getBattlecardById(key);
        
      if (response.data && response.data.success) {
        setBattlecardData(response.data); // Assuming the full data is nested
      } else {
        navigate('/battlecard');
        setError('Battlecard not found or an error occurred.');
      }
    } catch (err) {
      console.error('Failed to fetch battlecard:', err);
      setError('Failed to load battlecard. It may have been deleted or the link is invalid.');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div style={{ 
        minHeight: '100vh', 
        background: '#0f172a', 
        fontFamily: 'sans-serif', 
        color: '#e2e8f0',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '20px'
      }}>
        <div style={{
          background: '#1e293b',
          borderRadius: '16px',
          padding: '48px',
          boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
          border: '1px solid #334155',
          textAlign: 'center',
          maxWidth: '400px',
          width: '100%'
        }}>
          {/* Animated Loading Spinner */}
          <div style={{
            width: '64px',
            height: '64px',
            border: '4px solid #334155',
            borderTop: '4px solid #3b82f6',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
            margin: '0 auto 24px auto'
          }}></div>
          
          {/* Loading Text */}
          <h2 style={{
            fontSize: '24px',
            fontWeight: '700',
            color: '#ffffff',
            marginBottom: '12px'
          }}>
            Loading Battle Card
          </h2>
          
          <p style={{
            fontSize: '16px',
            color: '#94a3b8',
            marginBottom: '0'
          }}>
            Preparing your competitive analysis...
          </p>
        </div>
        
        {/* CSS Animation */}
        <style>
          {`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}
        </style>
      </div>
    );
  }

  if (!battlecardData) {
    return (
      <div style={{ 
        minHeight: '100vh', 
        background: '#0f172a', 
        fontFamily: 'sans-serif', 
        color: '#e2e8f0',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '20px'
      }}>
        <div style={{
          background: '#1e293b',
          borderRadius: '16px',
          padding: '48px',
          boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
          border: '1px solid #334155',
          textAlign: 'center',
          maxWidth: '400px',
          width: '100%'
        }}>
          <div style={{
            width: '64px',
            height: '64px',
            background: 'rgba(239, 68, 68, 0.1)',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 24px auto'
          }}>
            <svg style={{ width: '32px', height: '32px', color: '#ef4444' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          
          <h2 style={{
            fontSize: '24px',
            fontWeight: '700',
            color: '#ffffff',
            marginBottom: '12px'
          }}>
            No Battle Card Found
          </h2>
          
          <p style={{
            fontSize: '16px',
            color: '#94a3b8',
            marginBottom: '24px'
          }}>
            The battle card you're looking for doesn't exist or has been removed.
          </p>
          
          <button 
            onClick={() => navigate('/battlecard')}
            style={{
              background: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)',
              color: '#ffffff',
              padding: '12px 24px',
              border: 'none',
              borderRadius: '8px',
              fontSize: '16px',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'transform 0.2s',
              boxShadow: '0 10px 15px -3px rgba(59, 130, 246, 0.3)'
            }}
            onMouseEnter={(e) => e.target.style.transform = 'scale(1.02)'}
            onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
          >
            Create New Battle Card
          </button>
        </div>
      </div>
    );
  }

  // Validate data structure - handle the actual API response format
  if (!battlecardData.data || !battlecardData.data.external || !battlecardData.data.internal) {
    console.error('Invalid battlecard data structure:', battlecardData);
    setError('Invalid data structure received from API');
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', flexDirection: 'column' }}>
        <div style={{ color: '#dc2626', marginBottom: '20px' }}>Error: Invalid data structure</div>
        <button 
          onClick={() => navigate('/battlecard')}
          style={{
            background: '#3b82f6',
            color: '#ffffff',
            padding: '10px 20px',
            border: 'none',
            borderRadius: '6px',
            cursor: 'pointer'
          }}
        >
          Back to Form
        </button>
      </div>
    );
  }

  // Extract the battle card data from the correct structure
  const { external, internal } = battlecardData.data;

  // Safe access helper function
  const safeGet = (obj, path, defaultValue = '') => {
    try {
      return path.split('.').reduce((current, key) => current && current[key], obj) || defaultValue;
    } catch (error) {
      console.warn(`Error accessing path ${path}:`, error);
      return defaultValue;
    }
  };

  // Helper Components
  const Card = ({ children, className = '' }) => (
    <div style={{
      background: '#1e293b',
      boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
      borderRadius: '12px',
      padding: '32px 40px',
      marginBottom: '40px',
      ...className
    }}>
      {children}
    </div>
  );

  const CardTitle = ({ children }) => (
    <h2 style={{
      fontSize: '24px',
      fontWeight: 'bold',
      color: '#ffffff',
      marginBottom: '24px'
    }}>
      {children}
    </h2>
  );

  const SectionTitle = ({ children }) => (
    <h3 style={{
      fontSize: '20px',
      fontWeight: 'bold',
      color: '#93c5fd',
      marginBottom: '20px',
      marginTop: '24px',
      textTransform: 'uppercase',
      letterSpacing: '0.05em'
    }}>
      {children}
    </h3>
  );

  const SubSectionTitle = ({ children }) => (
    <h4 style={{
      fontWeight: '600',
      color: '#ffffff',
      marginTop: '20px',
      marginBottom: '12px',
      fontSize: '16px'
    }}>
      {children}
    </h4>
  );

  const Pill = ({ children }) => (
    <span style={{
      display: 'inline-block',
      background: 'rgba(30, 64, 175, 0.5)',
      color: '#93c5fd',
      borderRadius: '9999px',
      padding: '4px 12px',
      fontSize: '14px',
      fontWeight: '600',
      marginRight: '8px',
      marginBottom: '8px'
    }}>
      {children}
    </span>
  );

  const BulletList = ({ items }) => (
    <ul style={{
      listStyleType: 'disc',
      listStylePosition: 'inside',
      color: '#d1d5db',
      lineHeight: '1.7',
      paddingLeft: '0',
      margin: '0'
    }}>
      {items.map((item, index) => (
        <li key={index} style={{ 
          marginBottom: '12px',
          fontSize: '15px',
          paddingLeft: '8px'
        }}>{item}</li>
      ))}
    </ul>
  );

  // External Battlecard Components
  const ExternalHeader = ({ data }) => (
    <header style={{ textAlign: 'center', marginBottom: '48px', paddingTop: '48px' }}>
      <h1 style={{
        fontSize: '48px',
        fontWeight: '800',
        color: '#ffffff',
        letterSpacing: '-0.025em',
        marginBottom: '16px'
      }}>
        {data.title}
      </h1>
      <div style={{
        marginTop: '16px',
        display: 'flex',
        justifyContent: 'center',
        gap: '16px',
        flexWrap: 'wrap'
      }}>
        <Pill>{data.prospect.account_name}</Pill>
        <Pill>{data.prospect.industry}</Pill>
        <Pill>{Array.isArray(data.prospect.personas) ? data.prospect.personas.join(', ') : data.prospect.personas}</Pill>
      </div>
    </header>
  );

  const MessagingFramework = ({ data }) => {
    if (!data) {
      return (
        <Card>
          <CardTitle>Overview</CardTitle>
          <p style={{ color: '#d1d5db', lineHeight: '1.7' }}>Data not available</p>
        </Card>
      );
    }
    
    return (
      <>
        <Card>
          <CardTitle>Overview</CardTitle>
          <p style={{ 
            color: '#d1d5db', 
            lineHeight: '1.7',
            fontSize: '16px',
            marginBottom: '0'
          }}>
            {data.company_overview || 'Company overview not available'}
          </p>
        </Card>
        <Card>
          <CardTitle>Value Proposition</CardTitle>
          <p style={{ 
            color: '#d1d5db', 
            lineHeight: '1.7',
            fontSize: '16px',
            marginBottom: '0'
          }}>
            {data.core_value_proposition || 'Core value proposition not available'}
          </p>
        </Card>
      </>
    );
  };

  const ProblemSolutionFit = ({ data }) => (
    <Card>
      <CardTitle>Problem-Solution Fit</CardTitle>
      <SectionTitle>Problems We Solve</SectionTitle>
      <SubSectionTitle>Primary Pain Points</SubSectionTitle>
      <BulletList items={data?.problems_we_solve?.primary_pain_points || []} />
      <SubSectionTitle>Current State Issues</SubSectionTitle>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '24px', marginBottom: '32px' }}>
        <div>
          <h5 style={{ fontWeight: '500', color: '#9ca3af', marginBottom: '12px', fontSize: '15px' }}>Process Inefficiencies</h5>
          <BulletList items={data?.problems_we_solve?.current_state_issues?.process_inefficiencies || []} />
        </div>
        <div>
          <h5 style={{ fontWeight: '500', color: '#9ca3af', marginBottom: '12px', fontSize: '15px' }}>Technology Gaps</h5>
          <BulletList items={data?.problems_we_solve?.current_state_issues?.technology_gaps || []} />
        </div>
        <div>
          <h5 style={{ fontWeight: '500', color: '#9ca3af', marginBottom: '12px', fontSize: '15px' }}>Resource Constraints</h5>
          <BulletList items={data?.problems_we_solve?.current_state_issues?.resource_constraints || []} />
        </div>
      </div>

      <SectionTitle>Our Unique Approach</SectionTitle>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '24px', marginBottom: '32px' }}>
        {(data?.our_unique_approach?.differentiation_pillars || []).map((pillar, index) => (
          <div key={index}>
            <SubSectionTitle>{pillar.name}</SubSectionTitle>
            <p style={{ color: '#d1d5db', lineHeight: '1.7', fontSize: '15px' }}>{pillar.description}</p>
          </div>
        ))}
      </div>
      <SubSectionTitle>Key Differentiator Narrative</SubSectionTitle>
      <div style={{ color: '#d1d5db' }}>
        {(data?.our_unique_approach?.key_differentiator_narrative?.story_arc || []).map((p, i) => (
          <p key={i} style={{ marginBottom: '12px', lineHeight: '1.7', fontSize: '15px' }}>{p}</p>
        ))}
      </div>
    </Card>
  );

  const SolutionPositioning = ({ data }) => (
    <Card>
      <CardTitle>Solution Positioning</CardTitle>
      <SectionTitle>Use Case</SectionTitle>
      <p style={{ 
        color: '#d1d5db', 
        marginBottom: '24px',
        lineHeight: '1.7',
        fontSize: '15px'
      }}>{data.use_case.primary}</p>
      <SectionTitle>Business Impact</SectionTitle>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '32px' }}>
        <div>
          <h4 style={{ fontWeight: '600', color: '#ffffff', marginBottom: '12px', fontSize: '16px' }}>Strategic Goals</h4>
          <BulletList items={data.use_case.business_impact.strategic_goals} />
        </div>
        <div>
          <h4 style={{ fontWeight: '600', color: '#ffffff', marginBottom: '12px', fontSize: '16px' }}>Operational Improvements</h4>
          <BulletList items={data.use_case.business_impact.operational_improvements} />
        </div>
        <div>
          <h4 style={{ fontWeight: '600', color: '#ffffff', marginBottom: '12px', fontSize: '16px' }}>Risk Mitigation</h4>
          <BulletList items={data.use_case.business_impact.risk_mitigation} />
        </div>
      </div>
    </Card>
  );

  const FourCategoryTiles = ({ data }) => {
    if (!data || !Array.isArray(data)) {
      return (
        <Card>
          <CardTitle>Capabilities</CardTitle>
          <p style={{ color: '#d1d5db' }}>No category data available</p>
        </Card>
      );
    }
    
    return (
      <Card>
        <CardTitle>Capabilities</CardTitle>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))', gap: '24px' }}>
          {data.map((category, i) => (
            <div key={i} style={{
              background: 'rgba(15, 23, 42, 0.5)',
              padding: '24px',
              borderRadius: '8px'
            }}>
              <h4 style={{
                fontWeight: 'bold',
                fontSize: '18px',
                color: '#ffffff',
                marginBottom: '12px'
              }}>
                {category.one_liner}
              </h4>
              <BulletList items={category.bullets} />
              <p style={{
                color: '#60a5fa',
                fontStyle: 'italic',
                marginTop: '16px'
              }}>
                "{category.follow_up}"
              </p>
            </div>
          ))}
        </div>
      </Card>
    );
  };

  const QuotesAndSnippets = ({ data }) => (
    <Card>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '32px' }}>
        <div>
          <SectionTitle>Customer Quotes</SectionTitle>
          <div style={{ color: '#d1d5db' }}>
            {data.quotes.map((quote, i) => (
              <blockquote key={i} style={{
                borderLeft: '4px solid #3b82f6',
                paddingLeft: '16px',
                fontStyle: 'italic',
                marginBottom: '16px'
              }}>
                {quote}
              </blockquote>
            ))}
          </div>
        </div>
        <div>
          <SectionTitle>Key Snippets</SectionTitle>
          <BulletList items={data.snippets} />
        </div>
      </div>
    </Card>
  );

  const PatternDetector = ({ data }) => (
    <Card>
      <CardTitle>Pattern Detector in Action</CardTitle>
      <div style={{ marginBottom: '24px' }}>
        {data.layout.map((step, index) => (
          <div key={index} style={{
            display: 'flex',
            alignItems: 'flex-start',
            marginBottom: '16px'
          }}>
            <div style={{
              flexShrink: 0,
              background: '#2563eb',
              color: '#ffffff',
              width: '32px',
              height: '32px',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontWeight: 'bold',
              marginRight: '16px'
            }}>
              {index + 1}
            </div>
            <p style={{ color: '#d1d5db' }}>{step}</p>
          </div>
        ))}
      </div>
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
        gap: '24px',
        paddingTop: '24px',
        borderTop: '1px solid #334155'
      }}>
        <div>
          <SubSectionTitle>Cost of Waiting</SubSectionTitle>
          <p style={{ color: '#d1d5db' }}>{data.cost_of_waiting}</p>
        </div>
        <div>
          <SubSectionTitle>Safe First Step</SubSectionTitle>
          <p style={{ color: '#d1d5db' }}>{data.safe_first_step}</p>
        </div>
      </div>
    </Card>
  );

  const CompetitivePositioning = ({ data }) => {
    if (!data || !Array.isArray(data)) {
      return (
        <Card>
          <CardTitle>Competitive Positioning</CardTitle>
          <p style={{ color: '#d1d5db' }}>No competitive positioning data available</p>
        </Card>
      );
    }
    
    return (
      <Card>
        <CardTitle>Competitive Positioning</CardTitle>
        <div style={{ color: '#d1d5db' }}>
          {data.map((item, i) => (
            <div key={i} style={{ marginBottom: '16px' }}>
              <h4 style={{ fontWeight: 'bold', color: '#ffffff' }}>{item.competitor}</h4>
              <p style={{ color: '#d1d5db' }}>{item.positioning}</p>
            </div>
          ))}
        </div>
      </Card>
    );
  };

  const CtaSection = ({ data }) => (
    <div style={{ textAlign: 'center', margin: '48px 0' }}>
      <Card style={{ display: 'inline-block' }}>
        <h3 style={{
          fontSize: '24px',
          fontWeight: 'bold',
          color: '#ffffff',
          marginBottom: '8px'
        }}>
          {data.primary_cta}
        </h3>
        <p style={{ color: '#d1d5db' }}>{data.secondary_cta}</p>
      </Card>
    </div>
  );

  // Internal Battlecard Components
  const InternalHeader = ({ data }) => (
    <header style={{ textAlign: 'center', marginBottom: '48px', paddingTop: '48px' }}>
      <h1 style={{
        fontSize: '48px',
        fontWeight: '800',
        color: '#ffffff',
        letterSpacing: '-0.025em',
        marginBottom: '16px'
      }}>
        Internal Battlecard: {data.prospect.account_name}
      </h1>
      <div style={{
        marginTop: '16px',
        display: 'flex',
        justifyContent: 'center',
        gap: '16px',
        flexWrap: 'wrap'
      }}>
        <Pill>{data.prospect.stage}</Pill>
        <Pill>Persona: {Array.isArray(data.prospect.personas) ? data.prospect.personas.join(', ') : data.prospect.personas}</Pill>
      </div>
    </header>
  );

  const InternalContext = ({ data }) => (
    <Card>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '32px' }}>
        <div>
          <SectionTitle>Use Case</SectionTitle>
          <p style={{ color: '#d1d5db' }}>{data.use_case}</p>
          <SectionTitle>Elevator Pitch</SectionTitle>
          <p style={{ fontStyle: 'italic', color: '#93c5fd' }}>"{data.elevator_pitch}"</p>
        </div>
        <div>
          <SectionTitle>Key Metrics</SectionTitle>
          <p style={{ color: '#d1d5db' }}>
            <span style={{ fontWeight: '600', color: '#ffffff' }}>ROI Band:</span> {data.metrics.roi_band}
          </p>
          <p style={{ color: '#d1d5db' }}>
            <span style={{ fontWeight: '600', color: '#ffffff' }}>Time to First Insight:</span> {data.metrics.ttfi_hours}
          </p>
        </div>
      </div>
    </Card>
  );

  const Scenarios = ({ data }) => (
    <Card>
      <CardTitle>Engagement Scenarios</CardTitle>
      <div style={{ color: '#d1d5db' }}>
        {data.map((item, index) => (
          <div key={index} style={{
            background: 'rgba(15, 23, 42, 0.5)',
            padding: '24px',
            borderRadius: '8px',
            marginBottom: '32px'
          }}>
            <h4 style={{
              fontSize: '20px',
              fontWeight: 'bold',
              color: '#ffffff',
              marginBottom: '20px'
            }}>
              {item.name}
            </h4>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '32px' }}>
              <div>
                <SubSectionTitle>Loss Scenarios</SubSectionTitle>
                <BulletList items={item.loss_scenarios} />
                <SubSectionTitle>Early Warning Signs</SubSectionTitle>
                <BulletList items={item.early_warning_signs} />
              </div>
              <div>
                <SubSectionTitle>How to Respond</SubSectionTitle>
                <BulletList items={item.how_to_respond} />
                <SubSectionTitle>Disqualification Criteria</SubSectionTitle>
                <BulletList items={item.disqualification_criteria} />
                <p style={{
                  fontSize: '15px',
                  color: '#f87171',
                  fontStyle: 'italic',
                  marginTop: '20px',
                  lineHeight: '1.6',
                  padding: '12px',
                  background: 'rgba(248, 113, 113, 0.1)',
                  borderRadius: '6px',
                  border: '1px solid rgba(248, 113, 113, 0.2)'
                }}>
                  <span style={{ fontWeight: '600' }}>Graceful Exit:</span> {item.graceful_exit}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </Card>
  );

  const StrategyAndMessaging = ({ data }) => (
    <Card>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '40px' }}>
        <div>
          <SectionTitle>Recommended Strategy</SectionTitle>
          <p style={{ 
            color: '#d1d5db', 
            lineHeight: '1.7',
            fontSize: '15px',
            marginBottom: '24px'
          }}>
            <span style={{ fontWeight: '600', color: '#ffffff' }}>Start Option: </span>
            {data.recommended_start_option}
          </p>
          <SubSectionTitle>Talk Track & Probes</SubSectionTitle>
          <BulletList items={data.talk_track_and_probes} />
        </div>
        <div>
          <SectionTitle>Priority Messaging</SectionTitle>
          <SubSectionTitle>Tuned One-Liners</SubSectionTitle>
          <div style={{ 
            fontStyle: 'italic', 
            color: '#93c5fd',
            marginBottom: '24px'
          }}>
            {data.priority_messaging.tuned_one_liners.map((p, i) => (
              <p key={i} style={{ 
                marginBottom: '12px', 
                lineHeight: '1.6',
                fontSize: '15px',
                padding: '8px 12px',
                background: 'rgba(147, 197, 253, 0.1)',
                borderRadius: '6px',
                border: '1px solid rgba(147, 197, 253, 0.2)'
              }}>"{p}"</p>
            ))}
          </div>
          <SubSectionTitle>Bullets</SubSectionTitle>
          <BulletList items={data.priority_messaging.bullets} />
          <SubSectionTitle>Follow-up Bridges</SubSectionTitle>
          <BulletList items={data.priority_messaging.follow_up_bridges} />
        </div>
      </div>
    </Card>
  );

  const DiscoverySection = ({ data }) => (
    <Card>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '40px' }}>
        <div>
          <SectionTitle>Discovery Landmines</SectionTitle>
          <BulletList items={data.discovery_landmines} />
        </div>
        <div>
          <SectionTitle>Reverse Trap Questions</SectionTitle>
          <BulletList items={data.reverse_trap_questions} />
        </div>
      </div>
      <div style={{
        paddingTop: '32px',
        marginTop: '32px',
        borderTop: '1px solid #334155'
      }}>
        <SectionTitle>Discovery Questions</SectionTitle>
        <BulletList items={data.discovery_questions} />
      </div>
      <div style={{
        paddingTop: '32px',
        marginTop: '32px',
        borderTop: '1px solid #334155'
      }}>
        <SectionTitle>Top Discovery Questions</SectionTitle>
        {data.top_questions.map((q, i) => (
          <div key={i} style={{ 
            marginBottom: '20px',
            padding: '16px',
            background: 'rgba(15, 23, 42, 0.3)',
            borderRadius: '8px'
          }}>
            <p style={{ 
              fontWeight: '600', 
              color: '#ffffff',
              marginBottom: '8px',
              fontSize: '15px',
              lineHeight: '1.6'
            }}>"{q.question}"</p>
            <p style={{ 
              fontSize: '14px', 
              color: '#9ca3af',
              lineHeight: '1.5'
            }}>
              Why it works: {q.why_it_works}
            </p>
          </div>
        ))}
      </div>
    </Card>
  );

  const DemoAndTech = ({ data }) => (
    <Card>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '40px' }}>
        <div>
          <SectionTitle>Demo Strategy</SectionTitle>
          <div style={{ marginBottom: '24px' }}>
            <SubSectionTitle>Approach</SubSectionTitle>
            <p style={{ 
              color: '#d1d5db',
              lineHeight: '1.7',
              fontSize: '15px',
              marginBottom: '0'
            }}>
              {data.demo_strategy.approach}
            </p>
          </div>
          <div style={{ marginBottom: '24px' }}>
            <SubSectionTitle>Flow</SubSectionTitle>
            <p style={{ 
              color: '#d1d5db',
              lineHeight: '1.7',
              fontSize: '15px',
              marginBottom: '0'
            }}>
              {data.demo_strategy.flow}
            </p>
          </div>
          <div>
            <SubSectionTitle>Close</SubSectionTitle>
            <p style={{ 
              color: '#d1d5db',
              lineHeight: '1.7',
              fontSize: '15px',
              marginBottom: '0'
            }}>
              {data.demo_strategy.close}
            </p>
          </div>
        </div>
        <div>
          <SectionTitle>Technical Requirements</SectionTitle>
          <SubSectionTitle>Integration Prerequisites</SubSectionTitle>
          <BulletList items={data.technical_requirements.integration_prerequisites} />
          <SubSectionTitle>Security & Compliance</SubSectionTitle>
          <BulletList items={data.technical_requirements.security_compliance} />
        </div>
      </div>
    </Card>
  );

  const ObjectionHandling = ({ data }) => {
    if (!data || !Array.isArray(data)) {
      return (
        <Card>
          <CardTitle>Objection Handling</CardTitle>
          <p style={{ color: '#d1d5db', lineHeight: '1.7' }}>No objection handling data available</p>
        </Card>
      );
    }
    
    return (
      <Card>
        <CardTitle>Objection Handling</CardTitle>
        <div style={{ color: '#d1d5db' }}>
          {data.map((item, i) => (
            <div key={i} style={{
              background: 'rgba(15, 23, 42, 0.5)',
              padding: '20px',
              borderRadius: '8px',
              marginBottom: '20px'
            }}>
              <h4 style={{ 
                fontWeight: '600', 
                color: '#ffffff', 
                marginBottom: '12px',
                fontSize: '16px',
                lineHeight: '1.5'
              }}>
                "{item.objection}"
              </h4>
              <p style={{ 
                color: '#d1d5db',
                lineHeight: '1.7',
                fontSize: '15px'
              }}>{item.response}</p>
            </div>
          ))}
        </div>
      </Card>
    );
  };

  const renderExternalVersion = () => (
    <div style={{ maxWidth: 1200, margin: '0 auto', padding: '20px' }}>
      <ExternalHeader data={external} />
      <main>
        <MessagingFramework data={safeGet(external, 'solution_positioning.messaging_framework')} />
        <ProblemSolutionFit data={safeGet(external, 'solution_positioning.problem_solution_fit')} />
        <SolutionPositioning data={safeGet(external, 'solution_positioning')} />
        <FourCategoryTiles data={safeGet(external, 'category_tiles')} />
        <PatternDetector data={safeGet(external, 'pattern_detector')} />
        <QuotesAndSnippets data={safeGet(external, 'quotes_snippets')} />
        <CompetitivePositioning data={safeGet(external, 'competitive_positioning')} />
      </main>
      <CtaSection data={safeGet(external, 'container_cta')} />
    </div>
  );

  const renderInternalVersion = () => (
    <div style={{ maxWidth: 1200, margin: '0 auto', padding: '20px' }}>
      <InternalHeader data={internal} />
      <main>
        <InternalContext data={internal} />
        <Scenarios data={safeGet(internal, 'scenarios')} />
        <StrategyAndMessaging data={internal} />
        <DiscoverySection data={internal} />
        <DemoAndTech data={internal} />
        <ObjectionHandling data={safeGet(internal, 'objection_handling')} />
      </main>
    </div>
  );

  return (
    <div style={{ minHeight: '100vh', background: '#0f172a', fontFamily: 'sans-serif', color: '#e2e8f0' }}>
      {/* Toggle Controls */}
      <div style={{
        background: '#1e293b',
        padding: '16px',
        borderRadius: '8px',
        marginBottom: '32px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '16px',
        position: 'sticky',
     
        zIndex: 10
      }}>
        <button
          onClick={() => setActiveVersion('external')}
          style={{
            padding: '8px 16px',
            borderRadius: '6px',
            fontSize: '14px',
            fontWeight: '600',
            cursor: 'pointer',
            background: activeVersion === 'external' ? '#2563eb' : 'transparent',
            color: activeVersion === 'external' ? '#ffffff' : '#d1d5db',
            border: 'none',
            transition: 'all 0.2s'
          }}
        >
          External View
        </button>
        <button
          onClick={() => setActiveVersion('internal')}
          style={{
            padding: '8px 16px',
            borderRadius: '6px',
            fontSize: '14px',
            fontWeight: '600',
            cursor: 'pointer',
            background: activeVersion === 'internal' ? '#ca8a04' : 'transparent',
            color: activeVersion === 'internal' ? '#ffffff' : '#d1d5db',
            border: 'none',
            transition: 'all 0.2s'
          }}
        >
          Internal View
        </button>
      </div>

      {/* Content */}
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 16px' }}>
        {activeVersion === 'external' ? renderExternalVersion() : renderInternalVersion()}
      </div>
    </div>
  );
};

export default BattlecardResult;
